import React, { useState, forwardRef, useImperativeHandle } from 'react'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  ThemeProvider,
} from '@mui/material'
import { theme } from '../../../muiTheme'
import { Controller } from 'react-hook-form'
import { ExpandMore, ExpandLess } from '@mui/icons-material'
import TextField from './TextField'

export const SelectField = forwardRef(
  (
    {
      name,
      control,
      label,
      options,
      error,
      onChange,
      variant = 'filled',
      disabled = false,
      isSelectTime = false,
      ...props
    },
    ref
  ) => {
    const [openMenu, setOpenMenu] = useState(false)
    const handleOpen = () => {
      setOpenMenu(true)
    }
    const handleClose = () => {
      setOpenMenu(false)

      setTimeout(() => {
        document.activeElement.blur()
      })
    }

    // 👇 expose open() and close() to parent
    useImperativeHandle(ref, () => ({
      open: () => handleOpen(),
      close: () => handleClose(),
    }))
    return (
      <ThemeProvider theme={theme}>
        <div>
          {disabled ? (
            <TextField control={control} name={name} label={label} disabled />
          ) : (
            <Controller
              name={name}
              control={control}
              render={({ field }) => (
                <FormControl variant={variant} fullWidth>
                  <InputLabel id={`${name}-label`}>{label}</InputLabel>
                  <Select
                    IconComponent={({ className }) => {
                      return className?.includes('MuiSelect-iconOpen') ? (
                        <ExpandLess
                          sx={{
                            color: '#002677',
                            fontSize: '30px',
                            paddingRight: '6px',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setOpenMenu(false)
                            setTimeout(() => {
                              document.activeElement.blur()
                            })
                          }}
                        />
                      ) : (
                        <ExpandMore
                          sx={{
                            color: '#002677',
                            fontSize: '30px',
                            paddingRight: '6px',
                            cursor: 'pointer',
                          }}
                          onClick={() => setOpenMenu(true)}
                        />
                      )
                    }}
                    variant={variant}
                    labelId={`${name}-label`}
                    {...field}
                    value={field.value || ''}
                    onChange={(e) => {
                      field.onChange(e)
                      if (onChange) onChange(e)
                    }}
                    MenuProps={{
                      // disableRestoreFocus: true,
                      marginThreshold: null,
                      disableScrollLock: true,
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                      },
                      PaperProps: {
                        sx: {
                          '@media (max-width: 600px)': {
                            position: 'absolute !important',
                            maxHeight: '40vh !important',
                            width: '100% !important',
                            left: '12px !important',
                          },
                        },
                      },
                    }}
                    onOpen={handleOpen}
                    onClose={handleClose}
                    open={openMenu}
                    {...props}>
                    {options?.map((option) => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                        disabled={option.disabled}
                        onClick={(e) => {
                          if (onChange && isSelectTime) onChange(option.value)
                        }}>
                        {option.text}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
          )}

          {error && (
            <span className="field-validation-error error pb-0">
              {error.message}
            </span>
          )}
        </div>
      </ThemeProvider>
    )
  }
)
